interface CarouselDotsProps {
  pageCount: number;
  activePage: number;
  onPageChange: (page: number) => void;
}

export const CarouselDots = ({
  pageCount,
  activePage,
  onPageChange,
}: CarouselDotsProps) => {
  if (pageCount <= 1) return null;

  return (
    <div className="home-carousel-dots" aria-label="Carousel pages">
      {Array.from({ length: pageCount }, (_, index) => (
        <button
          key={index}
          type="button"
          className={`home-carousel-dot${
            index === activePage ? ' active' : ''
          }`}
          aria-label={`Go to page ${index + 1}`}
          aria-current={index === activePage ? 'true' : undefined}
          onClick={() => onPageChange(index)}
        />
      ))}
    </div>
  );
};
